import { render, staticRenderFns } from "./RecipesPage.vue?vue&type=template&id=4acdc4c5&"
import script from "./RecipesPage.vue?vue&type=script&lang=js&"
export * from "./RecipesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports